export const data: any = {
  NEXT_PUBLIC_SITE_MACHINE_NAME: "positioningservices",
  NEXT_PUBLIC_CF_MXP_SPACE_ID: "9k5dj5b59lqq",
  NEXT_PUBLIC_ONETRUST_ID: "c4b867da-0106-4cc2-85ba-b4958ea10d7e",
  NEXT_PUBLIC_ALGOLIA_SITE_INDEX: "positioningservices-production",
  BYPASS_CONSENT_CHECK: true
}
